import { jsx as n } from "react/jsx-runtime";
import { Component as s } from "react";
class m extends s {
  shouldComponentUpdate() {
    return !1;
  }
  render() {
    const { children: e, id: o, className: r } = this.props;
    return /* @__PURE__ */ n("div", { id: o, className: r, children: e });
  }
}
export {
  m as default
};
//# sourceMappingURL=UnmanagedDom.js.map
